module.exports = __webpack_public_path__ + "img/prediction.6e77981f.png";